module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block col-xs-12"
  }, [_c('div', {
    staticClass: "card insurance wide",
    class: {
      discontinue: _vm.opgeschort == 'J'
    },
    attrs: {
      "id": _vm.produkttypenaam
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "icon icon-fifty"
  }, [_c('span', {
    class: 'icon-' + _vm.produkttypenaam
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.produktnaam))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Mijn polisnummer: " + _vm._s(_vm.polisnummer))]), _vm._v(" "), (_vm.inbehandeling == 'J') ? _c('span', {
    staticClass: "tag"
  }, [_vm._v("in behandeling")]) : _vm._e(), _vm._v(" "), (_vm.opgeschort == 'J') ? _c('span', {
    staticClass: "tag"
  }, [_vm._v("tijdelijk stopgezet")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', [(_vm.omschrijving) ? _c('li', [_c('label', [_vm._v("Omschrijving")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.omschrijving))])]) : _vm._e(), _vm._v(" "), (_vm.soortpolis != 'VSP') ? _c('li', [_c('label', [_vm._v("Ter informatie")]), _vm._v(" "), _c('span', [_vm._v("De details van deze verzekering zijn alleen beschikbaar bij " + _vm._s(_vm.maatschappijnaam) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.kenteken) ? _c('li', [_c('label', [_vm._v("Kenteken")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.kenteken))])]) : _vm._e(), _vm._v(" "), (_vm.straat) ? _c('li', [_c('label', [_vm._v("Locatie")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.straat) + " te " + _vm._s(_vm.plaats))])]) : _vm._e(), _vm._v(" "), (_vm.looptijd > 0) ? _c('li', [_c('label', [_vm._v("Looptijd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.looptijd) + " dagen")])]) : _vm._e()])]), _vm._v(" "), (_vm.soortpolis == 'VSP') ? _c('div', {
    staticClass: "card-footer"
  }, [(_vm.opgeschort == 'N') ? _c('form', {
    attrs: {
      "action": _vm.ctx + '/wijzigpolis.html?polisid=' + _vm.poliswijzigid,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "poliswijzigid"
    },
    domProps: {
      "value": _vm.poliswijzigid
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Wijzigen")])]) : _vm._e(), _vm._v(" "), (_vm.opgeschort == 'N') ? _c('form', {
    attrs: {
      "action": _vm.ctx + _vm.schademeldenurl,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "polisurl"
    },
    domProps: {
      "value": _vm.polisurl
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Schade melden")])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.ctx + _vm.polisurl,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "polisurl"
    },
    domProps: {
      "value": _vm.polisurl
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Naar mijn polis")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1748cc67"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polis.vue
// module id = 23
// module chunks = 0